import Vue from 'vue'
import numeral from 'numeral'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import numFormat from 'vue-filter-number-format'

Vue.filter('numFormat', numFormat(numeral))
